var content = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--5-oneOf-0-3!../../../../node_modules/postcss-loader/src/index.js??ref--5-oneOf-0-4!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/fast-sass-loader/lib/index.js??ref--5-oneOf-0-6!./main.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
